import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Select } from 'components/common/form';

const CertificatesAddPath = ({ paths, templateId, updateTemplates }) => {
  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const submit = async (values) => {
    await api.post(`/admin/certificate-templates/${templateId}/paths`, {
      pathId: values.pathId
    });
    await updateTemplates();
    dispatch(
      actions.addNotice({
        text: 'Path added successfully',
        type: 'success'
      })
    );
  };

  return (
    <ModalButtonWithForm
      buttonIcon="plus"
      buttonText={'Add path'}
      modalActionText={messages.commonAdd}
      modalTitle={'Add path'}
      onSubmit={submit}
      pristineIsValid={false}
      stopPropagation={true}
    >
      {(formState) => (
        <FormGroup label={messages.commonPath}>
          <Select
            field="pathId"
            id={`certificate-templates-add-path-${templateId}`}
            options={paths.map((path) => ({
              label: path.title,
              value: path.id
            }))}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default CertificatesAddPath;
